import { createContext, useContext, useState } from "react"

const FarmerProfileContext = createContext({
  mainCardStatus: { backAction: true, header: true, tabs: true },
  hasBackButton: true,
  pageName: "Perfil do(a) beneficiário(a)"
});

export const FarmerProfileProvider = ({ children }) => {
  const [mainCardStatus, setMainCardStatus] = useState({ header: true, tabs: true });
  const [hasBackButton, setHasBackButton] = useState(true);
  const [pageName, setPageName] = useState("");
  const [userDetails, setUserDetails] = useState({})

  const hideMainCard = (componentName, status) => {
    if (!componentName) {
      setMainCardStatus({ header: status, tabs: status });
      
      return;
    }

    setMainCardStatus(curr => ({ ...curr, [componentName]: status }));
  }

  const handleChangeBackButton = (status) => {
    setHasBackButton(status)
  } 

  return <FarmerProfileContext.Provider 
    value={{
      hideMainCard,
      mainCardStatus,
      pageName,
      setPageName,
      hasBackButton,
      handleChangeBackButton,
      setUserDetails,
      userDetails
    }}
  >
    {children}
  </FarmerProfileContext.Provider>
}

export const useFarmerProfile = () => {
  return useContext(FarmerProfileContext);
}